import PosthogService from '~/services/posthog/PosthogService';

const event = 'dental_portal:notification:email_link_clicked';

/**
 * Fires when user lands on the value proposition page via the perm value prop reminder email CTA link
 * Event: dental_portal:notification:email_link_clicked
 */
export function firePermValuePropEmailLinkClicked(): void {
  PosthogService.getInstance().track(event, {
    email_type: 'perm_value_prop',
  });
}